import { render, staticRenderFns } from "./form-errors.html?vue&type=template&id=6670850c&scoped=true&"
import script from "./form-errors.js?vue&type=script&lang=js&"
export * from "./form-errors.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6670850c",
  null
  
)

export default component.exports